import { Navigation } from "swiper/modules";

const blockSlider = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const blocks = document.querySelectorAll('.block-slider__section');
        if (blocks.length == 0) return;

        blocks.forEach(block => {
            const slider = new Swiper(block, {
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                navigation: {
                    nextEl: block.querySelector('.swiper-button-next'),
                    prevEl: block.querySelector('.swiper-button-prev'),

                },
            });
        });
    })
}

export default blockSlider;